import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import MainPaper from "src/features/Components/MainPaper"
import { makeStyles } from "@material-ui/core/styles"
import { get } from "lodash"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Table from "./table"

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(2), marginBottom: theme.spacing(5) },
}))

const sort_timeline = (promotions) =>
  promotions
    .slice()
    .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))

const sort_default = (promotions) => [
  ...promotions.filter((item) => item.status === "active"),
  ...promotions
    .filter((item) => item.status === "upcoming")
    .slice()
    .sort((a, b) => new Date(a.start_date) - new Date(b.start_date)),
  ...promotions
    .filter((item) => item.status === "expired")
    .slice()
    .sort((a, b) => new Date(a.start_date) - new Date(b.start_date)),
]

function Index() {
  const classes = useStyles()
  const detail = useSelector((state) => state.supply.detail)
  const processing = useSelector((state) => state.supply.processing)
  const [promotions, setPromotions] = useState([])

  const [statusSort, setStatusSort] = useState("default")
  const handleStatusSort = (sort) => () => {
    setStatusSort(sort)
  }

  const [statusFilter, setStatusFilter] = useState("all")
  const handleStatusFilter = (status) => () => {
    setStatusFilter(status)
  }

  useEffect(() => {
    if (statusSort === "default" && statusFilter === "all") {
      setPromotions(sort_default(get(detail, "promotion", [])))
    } else if (statusSort === "timeline" && statusFilter === "all") {
      setPromotions(sort_timeline(get(detail, "promotion", [])))
    } else {
      setPromotions(
        get(detail, "promotion", []).filter(
          (item) => item.status === statusFilter
        )
      )
    }
  }, [processing, statusSort, statusFilter, detail])

  return (
    <MainPaper elevation={0} className={classes.root}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography>PROMOTION TIMELINE</Typography>
        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="body2">Sort by:</Typography>
            </Grid>
            {["default", "timeline"].map((item, key) => (
              <Grid item key={key}>
                <Button
                  variant="outlined"
                  color={statusSort === item ? "primary" : "default"}
                  onClick={handleStatusSort(item)}
                >
                  {item}
                </Button>
              </Grid>
            ))}
            <Grid item>
              <Typography variant="body2">Filter by:</Typography>
            </Grid>
            {["all", "active", "upcoming", "expired"].map((item, key) => (
              <Grid item key={key}>
                <Button
                  variant="outlined"
                  color={statusFilter === item ? "primary" : "default"}
                  onClick={handleStatusFilter(item)}
                >
                  {item}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Table promotions={promotions} />
    </MainPaper>
  )
}

export default Index
